import { render } from "./outstore.vue?vue&type=template&id=2ff750a0"
import script from "./outstore.vue?vue&type=script&lang=js"
export * from "./outstore.vue?vue&type=script&lang=js"

import "./outstore.vue?vue&type=style&index=0&id=2ff750a0&lang=less"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__